export default __webpack_public_path__ + "static/success-2a82146e7382c8d756243870c87320b8.png";